import React, { useState, useEffect } from "react";
import { Container, Form, Button, Spinner } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "../../helpers/swal";
import { resetPassword } from "../../api/user-service";
import * as Yup from "yup";
import { useFormik } from "formik";
import PasswordInput from "../../helpers/PasswordInput";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      toast("Invalid or missing token", "error");
      navigate("/");
    }
  }, [token, navigate]);

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Please enter your new password"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), null], "Passwords must match")
      .required("Please confirm your password"),
  });

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const onSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await resetPassword({
        token,
        password: values.password,
      });

      toast(response.data.message, "success");
      navigate("/");
    } catch (error) {
      const message = error.response ? error.response.data.message : error.message;
      toast(message, "error");
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <Container className="mt-5" style={{ maxWidth: "400px" }}>
      <h3 className="mb-4">Reset Your Password</h3>
      <Form onSubmit={formik.handleSubmit}>

        <PasswordInput
          placeholder="New Password"
          {...formik.getFieldProps("password")}
          isInvalid={formik.touched.password && formik.errors.password}
          isValid={formik.touched.password && !formik.errors.password}
          error={formik.errors.password}
        />

        <PasswordInput
          placeholder="Confirm Password"
          {...formik.getFieldProps("confirmPassword")}
          isInvalid={formik.touched.confirmPassword && formik.errors.confirmPassword}
          isValid={formik.touched.confirmPassword && !formik.errors.confirmPassword}
          error={formik.errors.confirmPassword}
        />

        <Button
          type="submit"
          variant="primary"
          className="mt-3 w-100"
          disabled={!(formik.dirty && formik.isValid) || loading}
        >
          {loading && <Spinner animation="border" size="sm" />} Reset Password
        </Button>
      </Form>
    </Container>
  );
};

export default ResetPasswordPage;
